import { createGlobalStyle } from 'styled-components';

export const MachineDetailsRobotRouteImageGlobalStyles = createGlobalStyle`
  .ant-image-preview-img {
    border: 1px solid ${(props): string => props.theme.colors.black};
    ${(props): string => props.theme.mixins.dropShadow}
  }
  
  .robot-ctr-image__preview-route-image-render {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 40px;
  }

  .robot-ctr-image__preview-route-image-title {
    ${(props): string => props.theme.fontStyles.heading3};
    color: ${(props): string => props.theme.colors.white};
    display: block;
    position: absolute;
    top: 55px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1200;
  }

  .robot-ctr-image__preview-route-image-content {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: center center;
    z-index: 1001;
  }

  .robot-ctr-image__preview-route-image-loading-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1100;
  }

  .ant-image-preview-operations-wrapper {
    .toolbar-wrapper {
      position: fixed;
      bottom: 25px;
      left: 50%;
      padding: 0px 24px;
      color: ${(props): string => props.theme.colors.white};
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 100px;
      transform: translateX(-50%);

      span {
        padding: 10px;
        cursor: pointer;
      }
    }
  }
`;
